import React, { Component } from "react"
import { connect } from "react-redux"
import { SaleAttributionService, buildTransaction, saveCompletedAttributions } from "../normalizer"

class CompletedAttributionsContainer extends Component {
  state = {
    page: 1
  }

  getCompletedSaleAttributions() {
    const { user, campaign, filterFrom, filterTo, filterContract } = this.props

    const payload = {
      clientSlug: user.client.slug,
      campaignSlug: campaign.slug,
      page: this.state.page,
      from: filterFrom || undefined,
      to: filterTo || undefined,
      contractNumber: filterContract || undefined,
    }

    this.props.startTransaction(() =>
      SaleAttributionService.getCompletedSaleAttributions(payload).then(response => {
        const raw = response.data.sales_completed || []
        // Deduplicate by id to guard against API returning duplicate rows
        const seen = new Set()
        const sales_completed = raw.filter(item => {
          if (seen.has(item.id)) return false
          seen.add(item.id)
          return true
        })
        const pagination = response.data.pagination
        this.props.saveCompletedAttributions(sales_completed, pagination)
      })
    )
  }

  handlePageChange = data => {
    this.setState({ page: data.selected + 1 }, () =>
      this.getCompletedSaleAttributions()
    )
  }

  componentDidMount() {
    this.getCompletedSaleAttributions()
  }

  componentDidUpdate(prevProps) {
    const { filterFrom, filterTo, filterContract } = this.props
    if (
      prevProps.filterFrom !== filterFrom ||
      prevProps.filterTo !== filterTo ||
      prevProps.filterContract !== filterContract
    ) {
      this.setState({ page: 1 }, () => this.getCompletedSaleAttributions())
    }
  }

  render() {
    const { component: Component, ...rest } = this.props
    return (
      <Component
        {...rest}
        page={this.state.page}
        onPageChange={this.handlePageChange}
      />
    )
  }
}

const mapStateToProps = state => ({
  user: state.userReducer.user,
  campaign: state.campaignReducer.campaign,
  completedSaleAttributions: state.saleAttributionReducer.completedSaleAttributions,
  completedPagination: state.saleAttributionReducer.completedPagination
})

const mapDispatchToProps = dispatch => ({
  saveCompletedAttributions: (completedAttributions, pagination) =>
    dispatch(saveCompletedAttributions(completedAttributions, pagination)),
  startTransaction: buildTransaction(dispatch)
})

const Container = connect(mapStateToProps, mapDispatchToProps)(CompletedAttributionsContainer)

export function withCompletedAttributionsContainer(component) {
  return (props) => <Container component={component} {...props} />
}

export default Container
